// @flow
import React, { useContext } from 'react';

import {
  FieldArrayGridConfigItemContext,
  FieldArrayGridTextField,
} from '../../../../../../formik-utils/FieldArrayGrid';
import { getDiscountColumnConfig, getIfRowIsVBD } from '../../../../../custom-discounts/utils';

export const SPDimensionsConfigDiscountContainer = () => {
  const { columnsConfiguration, rowValues } = useContext(FieldArrayGridConfigItemContext);
  const discountColumnConfig = getDiscountColumnConfig(columnsConfiguration);
  return (
    <FieldArrayGridTextField
      columnConfig={discountColumnConfig}
      disableOnFormErrors={null}
      disableTextField={getIfRowIsVBD(rowValues)}
    />
  );
};
